import {Component, Input,} from '@angular/core';

/**
 * A component that renders an SVG icon for "Chevron Down"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-chevron-down',
    templateUrl: './icon-chevron-down.component.html',
    styleUrls: ['./icon-chevron-down.component.scss'],
    standalone: false
})
export class IconChevronDownComponent {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
